module.exports = __webpack_public_path__ + "img/mesacompcdesligado.bb1e6be2.webp";